import { BaseService } from './base-service';
export class StatusRuleService {
    // ----------------------------------------------------------------------
    // Status Rules
    // ----------------------------------------------------------------------
    static getSchemas() {
        return BaseService.get(`status-rules/schemas`);
    }
    static getValues(schema) {
        return BaseService.get(`status-rules/values/${schema}`);
    }
    static saveValue(item) {
        return BaseService.save(`status-rules/values`, item);
    }
    static deleteValue(oid) {
        return BaseService.delete(`status-rules/values/${oid}`);
    }
    static searchValueCombo(schema, selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`status-rules/search-values/${schema}/${selfId}?search=${qs}`);
    }
}
